<template>
    <div class="c-payments-summary">
        <div v-show="incompletedPayments.length > 0">
            <h6 class="text-muted">{{Core.Definition.getDefinition('Paiements non complétés')}}</h6>
            <List
                    ref="listIncompletedPayments"
                    :options="{
                        emptyText: Core.Definition.getDefinition('Aucun paiement en attente'),
                        pagination: false,
                        header: true,
                        responsive: false,
                        striped: true
                     }"
                    :selectOptions="{
                        status: Core.Payment.statusOptions(),
                        method: Core.Payment.methodOptions()
                    }"
                    :columns="dataColumns"
                    :rows="incompletedPayments">
            </List>
            <hr/>
        </div>
        <div v-if="displayCompletedPayment">
            <h6 class="text-muted">{{Core.Definition.getDefinition('Paiements complétés')}}</h6>
            <List
                    ref="listCompletedPayments"
                    :options="{
                        emptyText: Core.Definition.getDefinition('Aucun paiement n\'a été effectué'),
                        pagination: false,
                        header: true,
                        responsive: false,
                        striped: true
                    }"
                    :selectOptions="{
                        status: Core.Payment.statusOptions(),
                        method: Core.Payment.methodOptions()
                    }"
                    :columns="dataCompletedColumns"
                    :rows="completedPayments">
            </List>
            <hr/>
        </div>
        <div v-if="displayFullCompletedPayment">
            <h6 class="text-muted">{{Core.Definition.getDefinition('Paiements complétés')}}</h6>
            <List
                    ref="listFullCompletedPayments"
                    :options="{
                        emptyText: Core.Definition.getDefinition('Aucun paiement n\'a été effectué'),
                        pagination: false,
                        header: true,
                        responsive: false,
                        striped: true
                    }"
                    :selectOptions="{
                        status: Core.Payment.statusOptions(),
                        method: Core.Payment.methodOptions()
                    }"
                    :columns="dataFullCompletedColumns"
                    :rows="completedPayments">
            </List>
            <hr/>
        </div>

        <div v-if="displayPaymentStatus" class="card-group mb-4 animated fadeIn">
            <div class="card"
                 :class="{'bg-light': dataPaymentStatus === Core.Payment.statusFree, 'bg-warning': dataPaymentStatus === Core.Payment.statusWaiting, 'bg-success': dataPaymentStatus === Core.Payment.statusCompleted, 'bg-danger': dataPaymentStatus === (Core.Payment.statusRefunded || Core.Payment.statusCancelled)}">
                <div class="card-body">
                    <div class="h4 mb-0">{{Core.Payment.statusLabel(dataPaymentStatus)}}</div>
                    <small class="text-muted text-uppercase font-weight-bold">{{Core.Definition.getDefinition("État")}}</small>
                </div>
            </div>
            <div class="card">
                <div class="card-body">
                    <div class="h4 mb-0">{{Core.Currency.format(dataSubTotal)}}</div>
                    <small class="text-muted text-uppercase font-weight-bold">{{Core.Definition.getDefinition("Sous-total")}}</small>
                </div>
            </div>
            <div class="card">
                <div class="card-body">
                    <div class="h4 mb-0">{{Core.Currency.format(dataTotal)}}</div>
                    <small class="text-muted text-uppercase font-weight-bold">{{Core.Definition.getDefinition("Total")}}</small>
                </div>
            </div>
            <div class="card">
                <div class="card-body">
                    <div class="h4 mb-0">{{Core.Currency.format(dataCompleted)}}</div>
                    <small class="text-muted text-uppercase font-weight-bold">{{Core.Definition.getDefinition("Payé")}}</small>
                </div>
            </div>
            <div class="card">
                <div class="card-body">
                    <div class="h4 mb-0">{{Core.Currency.format(dataBalance)}}</div>
                    <small class="text-muted text-uppercase font-weight-bold">{{Core.Definition.getDefinition("Balance")}}</small>
                </div>
            </div>
            <div class="card">
                <div class="card-body">
                    <div class="h4 mb-0">{{Core.Currency.format(dataRefunded)}}</div>
                    <small class="text-muted text-uppercase font-weight-bold">{{Core.Definition.getDefinition("Remboursé")}}</small>
                </div>
            </div>
        </div>

        <b-modal :title="Core.Definition.getDefinition('Modification du paiement')" class="modal-info"
                 v-model="dataEditModal.show" @ok="saveEdit" :ok-title="Core.Definition.getDefinition('Ok')"
                 ok-variant="edit" :cancel-title="Core.Definition.getDefinition('Annuler')"
                 cancel-variant="light">
            <b-row>
                <b-col lg="12" sm="12">
                    <Alert :alert="{ variant: 'warning', show: Core.Value.encode(dataEditModal.payment.method, 'select') === Core.Payment.methodCC, message: Core.Definition.getDefinition('La modification du paiement est limité, puisque celui-ci à été effectué par carte de crédit.') }"></Alert>
                </b-col>
            </b-row>

            <b-row class="mt-3">
                <b-col lg="6" md="6" sm="12">
                    <InputDate
                            :ref="id + '_editDate'"
                            :id="id + '_editDate'"
                            :readOnly="Core.Value.decode(dataEditModal.payment.method, 'select') === Core.Payment.methodCC && dataEditModal.payment.status === Core.Payment.statusCompleted"
                            :label="Core.Definition.getDefinition('Date')"
                            v-model="dataEditModal.payment.date"></InputDate>
                </b-col>
                <b-col lg="6" md="6" sm="12">
                    <InputText
                            :ref="id + '_editReferenceNumber'"
                            :id="id + '_editReferenceNumber'"
                            :readOnly="Core.Value.decode(dataEditModal.payment.method, 'select') === Core.Payment.methodCC && dataEditModal.payment.status === Core.Payment.statusCompleted"
                            :label="Core.Definition.getDefinition('# référence')"
                            v-model="dataEditModal.payment.referenceNumber"></InputText>
                </b-col>
            </b-row>

            <b-row class="mt-3">
                <b-col lg="6" md="6" sm="12">
                    <InputCurrency
                            :ref="id + '_editSubTotal'"
                            :id="id + '_editSubTotal'"
                            :readOnly="Core.Value.decode(dataEditModal.payment.method, 'select') === Core.Payment.methodCC && dataEditModal.payment.status === Core.Payment.statusCompleted"
                            :label="Core.Definition.getDefinition('Sous-total')"
                            v-model="dataEditModal.payment.subTotal"></InputCurrency>
                </b-col>
                <b-col lg="6" md="6" sm="12">
                    <InputSelect
                            :ref="id + '_editMethod'"
                            :id="id + '_editMethod'"
                            :readOnly="Core.Value.decode(dataEditModal.payment.method, 'select') === Core.Payment.methodCC && dataEditModal.payment.status === Core.Payment.statusCompleted"
                            :options="Core.Payment.methodOptions()"
                            :label="Core.Definition.getDefinition('Méthode')"
                            v-model="dataEditModal.payment.method"></InputSelect>
                </b-col>
            </b-row>

            <b-row class="mt-3">
                <b-col lg="7" md="7" sm="12">
                    <InputSelect
                            :ref="id + '_editStatus'"
                            :id="id + '_editStatus'"
                            :readOnly="Core.Value.decode(dataEditModal.payment.method, 'select') === Core.Payment.methodCC && dataEditModal.payment.status === Core.Payment.statusCompleted"
                            :description="Core.Definition.getDefinition('L\'état remboursé ou annulé est à titre indicatif. Aucun remboursement sera effectué à l\'acheteur.')"
                            :options="Core.Payment.statusOptions([
                                     Core.Payment.statusWaiting,
                                     Core.Payment.statusCancelled,
                                     Core.Payment.statusFailed,
                                     Core.Payment.statusRefunded])"
                            :label="Core.Definition.getDefinition('État du paiement')"
                            v-model="dataEditModal.payment.status"></InputSelect>
                </b-col>
            </b-row>
        </b-modal>

        <b-modal :title="Core.Definition.getDefinition('Suppression du paiement')" class="modal-danger" v-model="dataTrashModal.show" @ok="confirmTrash" :ok-title="Core.Definition.getDefinition('Supprimer')" ok-variant="danger" :cancel-title="Core.Definition.getDefinition('Annuler')" cancel-variant="light">
            <p>
                {{Core.Definition.getDefinition('Êtes-vous sûr de vouloir supprimer ce paiement?')}}
            </p>
        </b-modal>

        <ModalPayment
                ref="modalPayment"
                v-model="dataPayment"
                @onPaymentCompleted="onPaymentCompleted"
                @onTokenizationSuccess="onTokenizationSuccess"
                :forceTotal="false">
        </ModalPayment>
    </div>
</template>

<script>
    import List from './List'
    import Alert from './Alert'
    import InputSelect from "./InputSelect"
    import InputDate from "./InputDate"
    import InputText from "./InputText"
    import InputCurrency from "./InputCurrency"
    import ModalPayment from "./ModalPayment"
    export default {
        name: 'PaymentsSummary',
        components: {
            InputCurrency,
            List,
            InputSelect,
            InputText,
            InputDate,
            Alert,
            ModalPayment
        },
        props: {
            id: {
                type: String,
                default: ''
            },
            displayMakePayment: {
                type: Boolean,
                default: true
            },
            displayCheckPayment: {
                type: Boolean,
                default: false
            },
            displayCompletedPayment: {
                type: Boolean,
                default: true
            },
            displayFullCompletedPayment: {
                type: Boolean,
                default: false
            },
            displayPaymentStatus: {
                type: Boolean,
                default: true
            },
            calcTotalOnEval: {
                type: Boolean,
                default: false
            },
            form: {
                type: Object,
                default: function () {
                    return {}
                }
            },
            fieldRefs: {
                type: Array,
                default: function () {
                    return []
                }
            },
            value: {
                type: Array,
                default: function () {
                    return []
                }
            }
        },
        watch: {
            value(val) {
                this.dataPayments = val,
                this.eval()
            },
            dataPayments: {
                handler(val) {
                    this.eval()
                    this.$emit('input', val)
                },
                deep: true
            },
            dataTotal: {
                handler(val) {
                    //this.eval()
                },
                deep: true
            }
        },
        mounted() {
            this.addActions()
            this.dataPayments = this.value
            this.dataTotal = this.total
        },
        data: () => {
            return {
                Core: window.Core,
                dataColumns: [
                    {
                        label: Core.Definition.getDefinition('Date'),
                        key: 'date',
                        type: Core.Value.typeDate
                    },
                    {
                        label: Core.Definition.getDefinition('État'),
                        key: 'status',
                        type: Core.Value.typeSelect
                    },
                    {
                        label: Core.Definition.getDefinition('Méthode'),
                        key: 'method',
                        type: Core.Value.typeSelect
                    },
                    {
                        label: Core.Definition.getDefinition('Sous-total'),
                        key: 'subTotal',
                        type: Core.Value.typeCurrency
                    },
                    {
                        label: Core.Definition.getDefinition('Taxes'),
                        key: 'totalTaxes',
                        type: Core.Value.typeCurrency
                    },
                    {
                        label: Core.Definition.getDefinition('Total'),
                        key: 'total',
                        type: Core.Value.typeCurrency
                    },
                    {
                        label: Core.Definition.getDefinition('# référence'),
                        key: 'referenceNumber',
                        type: Core.Value.typeText
                    }
                ],
                dataCompletedColumns: [
                    {
                        label: Core.Definition.getDefinition('Date'),
                        key: 'date',
                        type: Core.Value.typeDate
                    },
                    {
                        label: Core.Definition.getDefinition('État'),
                        key: 'status',
                        type: Core.Value.typeSelect
                    },
                    {
                        label: Core.Definition.getDefinition('Méthode'),
                        key: 'method',
                        type: Core.Value.typeSelect
                    },
                    {
                        label: Core.Definition.getDefinition('Montant payé'),
                        key: 'total',
                        type: Core.Value.typeCurrency
                    },
                    {
                        label: Core.Definition.getDefinition('# référence'),
                        key: 'referenceNumber',
                        type: Core.Value.typeText
                    }
                ],
                dataFullCompletedColumns: [
                    {
                        label: Core.Definition.getDefinition('Date'),
                        key: 'date',
                        type: Core.Value.typeDate
                    },
                    {
                        label: Core.Definition.getDefinition('État'),
                        key: 'status',
                        type: Core.Value.typeSelect
                    },
                    {
                        label: Core.Definition.getDefinition('Méthode'),
                        key: 'method',
                        type: Core.Value.typeSelect
                    },
                    {
                        label: Core.Definition.getDefinition('Sous-total'),
                        key: 'subTotal',
                        type: Core.Value.typeCurrency
                    },
                    {
                        label: Core.Definition.getDefinition('Taxes'),
                        key: 'totalTaxes',
                        type: Core.Value.typeCurrency
                    },
                    {
                        label: Core.Definition.getDefinition('Total'),
                        key: 'total',
                        type: Core.Value.typeCurrency
                    },
                    {
                        label: Core.Definition.getDefinition('# référence'),
                        key: 'referenceNumber',
                        type: Core.Value.typeText
                    }
                ],
                dataPayments: [],
                dataPaymentStatus: Core.Payment.statusWaiting,
                dataCompleted: 0,
                dataTotal: 0,
                dataSubTotal: 0,
                dataRefunded: 0,
                dataCancelled: 0,
                dataBalance: 0,
                dataFailed: 0,
                dataEditModal: {
                    show: false,
                    payment: {
                        date: '',
                        method: '',
                        status: '',
                        referenceNumber: '',
                        subTotal: 0,
                        total: 0,
                        id: ''
                    },
                    index: ''
                },
                dataTrashModal: {
                    show: false,
                    index: ''
                },
                dataPayment: {
                    index: 0,
                    date: '',
                    method: Core.Select.select(Core.Payment.methodCash, Core.Payment.methodOptions()),
                    status: null,
                    referenceNumber: '',
                    subTotal: 0,
                    total: 0,
                    token : '',
                    id:''
                }
            }
        },
        computed: {
            total: {
                set(val) {
                    this.dataTotal = val
                    this.eval()
                },
                get() {
                    return this.dataTotal
                }
            },
            subTotal: {
                set(val) {
                    this.dataSubTotal = val
                },
                get() {
                    return this.dataSubTotal
                }
            },
            completed: {
                set(val) {
                    this.dataCompleted = val
                },
                get() {
                    return this.dataCompleted
                }
            },
            balance: {
                set(val) {
                    this.dataBalance = val
                },
                get() {
                    return this.dataBalance
                }
            },
            completedPayments() {
                let completedPayments = []
                for(let payment in this.dataPayments) {
                    payment = this.dataPayments[payment]
                    if (payment.status === Core.Payment.statusCompleted) {
                        completedPayments.push(payment)
                    }
                }
                return completedPayments
            },
            incompletedPayments() {
                let incompletedPayments = []
                for(let payment in this.dataPayments) {
                    payment = this.dataPayments[payment]
                    if (payment.status !== Core.Payment.statusCompleted) {
                        incompletedPayments.push(payment)
                    }
                }
                return incompletedPayments
            }
        },
        methods: {
            addPayment(date, status, method, subTotal, referenceNumber, id) {
                if (Core.Validation.isId(id)) {
                    id = Core.Text.generateHash()
                }
                if (subTotal === undefined || subTotal === '') {
                    subTotal = 0
                }

                subTotal = subTotal.toString().replace(',', '.')
                this.dataPayments.push({
                    date: date,
                    status: status,
                    method: method,
                    subTotal: subTotal,
                    referenceNumber: referenceNumber,
                    id: Core.Text.generateHash()
                })
            },
            eval() {
                let completed = 0
                let waiting = 0
                let refunded = 0
                let failed = 0
                let cancelled = 0
                let subTotal = 0

                let taxes = Core.Session.Setting.getTaxes()

                for (let paymentIndex in this.dataPayments) {
                    this.dataPayments[paymentIndex].index = paymentIndex

                    if (this.displayFullCompletedPayment) {
                        let totalTaxes = Core.Taxes.totalTaxes(this.dataPayments[paymentIndex].subTotal.toString().replace(',', '.'), taxes)
                        this.dataPayments[paymentIndex].total = (parseFloat(this.dataPayments[paymentIndex].subTotal.toString().replace(',', '.')) + parseFloat(totalTaxes)).toFixed(2)
                        this.dataPayments[paymentIndex].totalTaxes = totalTaxes.toFixed(2)
                    } else {
                        if (isNaN(this.dataPayments[paymentIndex].total)) {
                            this.dataPayments[paymentIndex].total = parseFloat(this.dataPayments[paymentIndex].subTotal.toString().replace(',', '.'))
                            this.dataPayments[paymentIndex].totalTaxes = 0
                        }
                    }

                    this.dataPayments[paymentIndex].Readable_totalTaxes = Core.Currency.format(this.dataPayments[paymentIndex].totalTaxes)
                    this.dataPayments[paymentIndex].Readable_total = Core.Currency.format(this.dataPayments[paymentIndex].total)
                    this.dataPayments[paymentIndex].Readable_subTotal = Core.Currency.format(this.dataPayments[paymentIndex].subTotal)

                    let payment = this.dataPayments[paymentIndex]
                    switch (payment.status) {
                        case Core.Payment.statusCompleted:
                            completed = completed + parseFloat(payment.total)
                            break
                        case Core.Payment.statusCancelled:
                            cancelled = cancelled + parseFloat(payment.total)
                            break
                        case Core.Payment.statusWaiting:
                            waiting = waiting + parseFloat(payment.subTotal)
                            break
                        case Core.Payment.statusFailed:
                            failed = failed + parseFloat(payment.total)
                            break
                        case Core.Payment.statusRefunded:
                            refunded = refunded + parseFloat(payment.total)
                            break
                    }

                    subTotal += parseFloat(payment.subTotal)
                }

                if (this.calcTotalOnEval) {
                    this.dataSubTotal = parseFloat(subTotal).toFixed(2)
                    this.dataTotal = parseFloat(this.dataSubTotal) + Core.Taxes.totalTaxes(this.dataSubTotal, taxes)
                }

                this.dataTotal = parseFloat(this.dataTotal).toFixed(2)

                this.dataCompleted = completed.toFixed(2)
                this.dataBalance = (this.dataTotal - this.dataCompleted).toFixed(2)
                this.dataRefunded = refunded.toFixed(2)
                this.dataFailed = failed.toFixed(2)
                this.dataCancelled = cancelled.toFixed(2)

                if (this.dataTotal == 0) {
                    this.dataPaymentStatus = Core.Payment.statusFree
                } else if (this.dataCompleted == this.dataTotal) {
                    this.dataPaymentStatus = Core.Payment.statusCompleted
                } else if (this.dataFailed == this.dataTotal) {
                    this.dataPaymentStatus = Core.Payment.statusFailed
                } else if (this.dataCancelled == this.dataTotal) {
                    this.dataPaymentStatus = Core.Payment.statusCancelled
                } else if (this.dataRefunded == this.dataTotal) {
                    this.dataPaymentStatus = Core.Payment.statusRefunded
                } else {
                    this.dataPaymentStatus = Core.Payment.statusWaiting
                }

                this.$emit('onEval', this.dataCompleted, this.dataBalance, this.dataPayments)
            },
            addActions() {

                if (this.displayCheckPayment) {
                    this.$refs.listIncompletedPayments.addAction('checkPayment', this.onCheckPaymentClick, '', '<button type="button" class="btn btn-light btn-sm"><i class=\'fa fa-check\'></i></button>', '', 'width:20px')
                }

                if (this.displayMakePayment) {
                    this.$refs.listIncompletedPayments.addAction('makePayment', this.onMakePaymentClick, '', '<button type="button" class="btn btn-success btn-sm">' + Core.Definition.getDefinition('Paiement') + '</button>', '', 'width:20px')
                }

                this.$refs.listIncompletedPayments.addAction('edit', this.onEditClick, '', '<button type="button" class="btn btn-edit btn-sm"><i class="fa fa-edit"></i></button>', '', 'width:20px')
                this.$refs.listIncompletedPayments.addAction('trash', this.onTrashClick, '', '<button type="button" class="btn btn-danger btn-sm"><i class="fa fa-trash"></i></button>', '', 'width:20px')

                if (this.displayCompletedPayment) {
                    this.$refs.listCompletedPayments.addAction('edit', this.onEditClick, '', '<button type="button" class="btn btn-edit btn-sm"><i class="fa fa-edit"></i></button>', '', 'width:20px')
                    this.$refs.listCompletedPayments.addAction('trash', this.onTrashClick, '', '<button type="button" class="btn btn-danger btn-sm"><i class="fa fa-trash"></i></button>', '', 'width:20px')
                }

                if (this.displayFullCompletedPayment) {
                    this.$refs.listFullCompletedPayments.addAction('edit', this.onEditClick, '', '<button type="button" class="btn btn-edit btn-sm"><i class="fa fa-edit"></i></button>', '', 'width:20px')
                    this.$refs.listFullCompletedPayments.addAction('trash', this.onTrashClick, '', '<button type="button" class="btn btn-danger btn-sm"><i class="fa fa-trash"></i></button>', '', 'width:20px')
                }
            },
            onEditClick(value, cell, row, rowIndex, columnIndex) {
                this.dataEditModal.payment = {
                    date: row.date,
                    method: Core.Value.selectValue(row.method, Core.Payment.methodOptions()),
                    status: Core.Value.selectValue(row.status, Core.Payment.statusOptions([
                        Core.Payment.statusWaiting,
                        Core.Payment.statusCompleted,
                        Core.Payment.statusCancelled,
                        Core.Payment.statusFailed,
                        Core.Payment.statusRefunded,
                    ])),
                    referenceNumber: row.referenceNumber,
                    subTotal: row.subTotal,
                    totalTaxes: row.totalTaxes,
                    total: row.total,
                    index: row.index,
                    isChecked: false,
                    id: row.id
                }
                this.dataEditModal.show = true
            },
            saveEdit() {
                let payment = this.dataEditModal.payment

                payment.subTotal = payment.subTotal.toString().replace(',', '.')
                this.dataPayments[payment.index].id = payment.id
                this.dataPayments[payment.index].isChecked = payment.isChecked
                this.dataPayments[payment.index].referenceNumber = payment.referenceNumber
                this.dataPayments[payment.index].Readable_referenceNumber = payment.referenceNumber
                this.dataPayments[payment.index].subTotal = payment.subTotal
                this.dataPayments[payment.index].Readable_subTotal = Core.Currency.format(payment.subTotal)
                this.dataPayments[payment.index].total = payment.total
                this.dataPayments[payment.index].Readable_total = Core.Currency.format(payment.total)
                this.dataPayments[payment.index].date = payment.date
                this.dataPayments[payment.index].Readable_date = Core.Date.readableDate(payment.date)
                this.dataPayments[payment.index].method = Core.Value.decode(payment.method, Core.Value.typeSelect)
                this.dataPayments[payment.index].Readable_method = Core.Select.label(payment.method)
                this.dataPayments[payment.index].status = Core.Value.decode(payment.status, Core.Value.typeSelect)
                this.dataPayments[payment.index].Readable_status = Core.Select.label(payment.status)

                this.eval()
            },
            onTrashClick(value, cell, row, rowIndex, columnIndex) {
                this.dataTrashModal.show = true
                this.dataTrashModal.index = row.index
            },
            confirmTrash() {
                this.dataPayments.splice(this.dataTrashModal.index, 1)
                this.dataTrashModal.show = false
            },
            onMakePaymentClick(value, cell, row, rowIndex, columnIndex) {
                this.dataPayment.index = row.index
                this.dataPayment.isChecked = row.isChecked
                this.dataPayment.method = Core.Select.select(row.method, Core.Payment.methodOptions())
                this.dataPayment.status = Core.Select.select(row.status, Core.Payment.statusOptions())
                this.dataPayment.subTotal = row.subTotal
                this.dataPayment.total = row.total
                this.dataPayment.totalTaxes = row.totalTaxes
                this.dataPayment.referenceNumber = row.referenceNumber
                this.dataPayment.date = row.date
                this.dataPayment.id = row.id
                this.$refs.modalPayment.open = true
            },
            onCheckPaymentClick(value, cell, row, rowIndex, columnIndex, component) {
                if (this.dataPayments[rowIndex].isChecked === undefined || this.dataPayments[rowIndex].isChecked === false) {
                    cell.value = '<button type=\'button\' class=\'btn btn-success btn-sm\'><i class=\'fa fa-check\'></i></button>'
                    this.dataPayments[rowIndex].isChecked = true
                } else {
                    cell.value = '<button type=\'button\' class=\'btn btn-light btn-sm\'><i class=\'fa fa-check\'></i></button>'
                    this.dataPayments[rowIndex].isChecked = false
                }
                this.$emit('onCheckPayment', this.dataPayments, this.fieldRefs)
                component.$forceUpdate()
            },
            onPaymentCompleted(payment) {
                this.$refs.modalPayment.open = false
                this.dataPayments[payment.index].id = payment.id
                this.dataPayments[payment.index].isChecked = payment.isChecked
                this.dataPayments[payment.index].referenceNumber = payment.referenceNumber
                this.dataPayments[payment.index].Readable_referenceNumber = payment.referenceNumber
                this.dataPayments[payment.index].status = Core.Payment.statusCompleted
                this.dataPayments[payment.index].Readable_status = undefined
                this.dataPayments[payment.index].method = Core.Value.decode(payment.method, Core.Value.typeSelect)
                this.dataPayments[payment.index].Readable_method = undefined
                this.eval()
                this.$emit('onPaymentCompleted', payment)
            },
            onTokenizationSuccess(payment){
                this.$refs.modalPayment.open = false
                this.$emit('onTokenizationSuccess',payment)
            }
        }
    }
</script>
